import Constants from '../../config.local.js'
import Accounting from '@/mixins/Accounting.js'
import Gynecologie from '@/mixins/Gynecologie.js'
import Horse from '@/mixins/Horse.js'
import Lieux from '@/mixins/Lieux.js'

var DashboardMixin = {
    mixins: [Accounting, Gynecologie, Horse, Lieux],
	methods: {
        createDashboard: async function(dashboards_name, dashboards_is_default, dashboards_shared_users, widgets = []) {
            const url = this.constructRoute(Constants.DASHBOARD_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const infos = { dashboards_name, dashboards_is_default, dashboards_shared_users, widgets }

            const response = await this.$request.request_post_api("DashboardMixin::createDashboard", url, infos, false)
            .catch(e => {
                console.error("DashboardMixin::createDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        getDashboards: async function() {
            const url = this.constructRoute(Constants.DASHBOARD_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_get_api("DashboardMixin::getDashboards", url, false)
            .catch(e => {
                console.error("DashboardMixin::getDashboards", e)
                this.failureToast("toast.info_get_failed")
            })

            return response.retour
        },
        updateDashboard: async function(dashboard_id, data) {
            const url = this.constructRoute(Constants.DASHBOARD_ID_URL, {dashboard_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_post_api("DashboardMixin::updateDashboard", url, data, false)
            .catch(e => {
                console.error("DashboardMixin::updateDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        deleteDashboard: async function(dashboard_id) {
            const url = this.constructRoute(Constants.DASHBOARD_ID_URL, {dashboard_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_delete_api("DashboardMixin::deleteDashboard", url, false)
            .catch(e => {
                console.error("DashboardMixin::deleteDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        getWidgetTypes: async function() {
            const url = this.constructRoute(Constants.WIDGET_TYPES_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_get_api("DashboardMixin::getWidgetTypes", url, false)
            .catch(e => {
                console.error("DashboardMixin::getWidgetTypes", e)
                this.failureToast("toast.info_get_failed")
            })

            return response.retour
        },
		getAllEntites: async function() {
			const entites = await this.loadAccountingPlans()
			return entites.map(e => ({
				code: e.accountingplan_id,
				label: e.accountingplan_label,
				currency: e.tiers.tiers_currency,
			}))
		},
        getAllResidences: async function() {
            const all_lieux = await this.getLieux(false)
            const residences = all_lieux.filter(lieu => lieu.lieu_type == 1)
            return residences.map(r => ({
                code: r.lieu_id,
                label: r.lieu_label,
            }))
        },
		getAllSeasonOptions: async function() {
			const seasons = await this.loadSeasons()
			return seasons.map(s => ({
				code: s.season_id,
				label: s.season_label,
			}))
		},
		getAllStallionOptions: async function() {
			const horses = await this.getHorsesStallion(false)
			return horses.map(h => ({
				code: h.horse_id,
				label: h.horse_nom,
			}))
		},
		getContractStatsMap: async function(params = {}) {
			let url = this.constructRoute(Constants.CONTRACT_STATS_MAP_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY + "&season_id=" + params.saison
			if (params.etalon) url += "&stallion_id=" + params.etalon
			const response = await this.$request.request_get_api("DashboardMixin::getContractStatsMap", url, false)
				.catch(e => {
					console.error("DashboardMixin::getContractStatsMap", e)
					return null
				})
			return response.retour
		},
		getCategoryHorseStats: async function(residence_id) {
			const url = this.constructRoute(Constants.CATEGORY_HORSE_URL, {residence_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("DashboardMixin::getCategoryHorseStats", url, false)
				.catch(e => {
					console.error("DashboardMixin::getCategoryHorseStats", e)
					return null
				})
			return response.retour
		},
        getUndoneActsStats: async function() {
            const url = Constants.UNDONE_ACTS_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const response = await this.$request.request_get_api("DashboardMixin::getUndoneActsStats", url, false)
                .catch(e => {
                    console.error("DashboardMixin::getUndoneActsStats", e)
                    return null
                })
            return response.retour
        },
        getPhysiologicalStateStats: async function() {
            const url = Constants.PHYSIOLOGICAL_STATES_WIDGET_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            const response = await this.$request.request_get_api("DashboardMixin::getPhysiologicalStateStats", url, false)
                .catch(e => {
                    console.error("DashboardMixin::getPhysiologicalStateStats", e)
                    return null
                })
            return response.retour
        },
    },
    // Relance loadData() du widget quand sa config change (ex: entité modifiée et enregistrée), sans reload de page.
    watch: {
		widget: {
			deep: true,
			handler() {
				this.loadData()
			},
		},
	},
}

export default DashboardMixin
